import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';

const MotoristaCard = ({ children }) => (
  <Card>
    <CardBody>{children}</CardBody>
  </Card>
);

export default MotoristaCard;
